import { useMemo } from 'react'
import dayjs from '@ucheba/utils/helpers/date/dayjs'

interface IUseRangeWorkTime {
  (): {
    isWorkTime: boolean
  }
}

export const useRangeWorkTime: IUseRangeWorkTime = () => {
  const date = new Date()

  const isWorkTime = useMemo(() => {
    const day = date.getDay()
    const hours = Number(dayjs().format('HH'))

    if (day !== 0 && day !== 1) {
      return hours >= 9 && hours < 21
    }

    return true
  }, [date])

  return {
    isWorkTime,
  }
}
